[
  {
    "code": "MP-NI",
    "name": "Northern Islands"
  },
  {
    "code": "MP-RO",
    "name": "Rota"
  },
  {
    "code": "MP-SA",
    "name": "Saipan"
  },
  {
    "code": "MP-TI",
    "name": "Tinian"
  }
]